import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/protected/_layout/invoices/_layout/')({
  component: () => null,
});
